import React, { useRef, useEffect } from "react";
import "./Clients.scss";
import safiriway_logo from "../../assets/images/logos/safiriway_logo.svg";
import goldensoko_logo from "../../assets/images/logos/goldensoko_logo.svg";
import migrart_logo from "../../assets/images/logos/migrart_logo.svg";
import dns_logo from "../../assets/images/logos/dns.svg";
import slyzed_logo from "../../assets/images/logos/slyzed_logo.svg";
import nomaad_logo from "../../assets/images/logos/nomaad_logo.svg";

const Clients = () => {
    const logos = [
        { id: 1, name: "SafiriWay", img: safiriway_logo },
        { id: 2, name: "GoldenSoko", img: goldensoko_logo },
        { id: 3, name: "Nomaad", img: nomaad_logo },
        { id: 4, name: "Migrart", img: migrart_logo },
        { id: 5, name: "Drop and Shop", img: dns_logo },
        { id: 6, name: "Slyzed", img: slyzed_logo },
    ];

    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        let isDown = false;
        let startX;
        let scrollLeft;

        const startDragging = (e) => {
            isDown = true;
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
            container.classList.add("dragging");
        };

        const stopDragging = () => {
            isDown = false;
            container.classList.remove("dragging");
        };

        const move = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 1.2;
            container.scrollLeft = scrollLeft - walk;
        };

        // For desktop drag-scroll
        container.addEventListener("mousedown", startDragging);
        container.addEventListener("mouseleave", stopDragging);
        container.addEventListener("mouseup", stopDragging);
        container.addEventListener("mousemove", move);

        // For mobile touch-scroll
        container.addEventListener("touchstart", (e) => {
            startX = e.touches[0].pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
        });
        container.addEventListener("touchmove", (e) => {
            const x = e.touches[0].pageX - container.offsetLeft;
            const walk = (x - startX) * 1.2;
            container.scrollLeft = scrollLeft - walk;
        });

        return () => {
            container.removeEventListener("mousedown", startDragging);
            container.removeEventListener("mouseleave", stopDragging);
            container.removeEventListener("mouseup", stopDragging);
            container.removeEventListener("mousemove", move);
        };
    }, []);

    return (
        <section className="clients">
            <h2>Our Software Development Services Were Chosen By</h2>

            <div className="clients__scroll-container">
                <div className="clients__logos" ref={containerRef}>
                    {logos.map((logo) => (
                        <div key={logo.id} className="client-logo">
                            <img src={logo.img} alt={logo.name} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Clients;
